import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface UpdateRequest {
    category: string;
    list_no: string;
    result?: number; // 1 | 2;
    memo?: string; // 관리자 메모
}

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleTrackingSupplies = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_way_bill.replace(":category", updateData.category).replace(":list_no", updateData.list_no);
            const response = await axiosInstance.put(url, {
                result: updateData.result,
                memo: updateData.memo,
            });
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleTrackingSupplies", "useGetConsoleTrackingSuppliesDetail"] });
            successCallback?.(data);
        },
    });
};
